import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { InjectConfig, SharedConfigKey } from '@ddt-web/config-layer';
import { StoreService } from '@ddt-web/store-service';
import * as get from 'lodash/get';
import { first } from 'rxjs/operators';

import { PdfGenerateStoreConfig } from '../../config/store.config';

@Component({
	selector: 'ac-pdf-yield-options',
	templateUrl: './pdf-yield-options.component.html',
	styleUrls: ['./pdf-yield-options.component.scss']
})
export class PdfYieldOptionsComponent implements OnInit {
	@InjectConfig(SharedConfigKey.ENABLE_SCENARIO_ADVISORY_FEE) public readonly isScenarioAdvisoryFeeEnabled: boolean = false;

	@Input() public yieldConfig: any;
	@Input() public disableYield: boolean;
	@Input() public showScenarioYield: boolean;
	@Input() public showEmailLink: boolean;
	@Input() public showAllActionsPerformed: boolean;
	@Input() public showTooManyActFundsAlert: boolean;
	@Input() public showTooManyFundsAlert: boolean;
	@Input() public showDisabledButtonAlert: boolean;
	@Input() public hideYield: boolean;
	@Input() public showPrivacyDisclaimer: boolean;
	@Input() public privacyUrl: string;
	@Output() public includeYieldChange: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() public includeScenarioYieldChange: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() public clientEmailChange: EventEmitter<void> = new EventEmitter<void>();

	public showYield: boolean = false;
	// 'includeYield' is only used for snapshot yield, and will always be false by default, cannot be driven from any tab/component.
	public includeYield: boolean = false;
	public includeScenarioYield: boolean = false;
	public yieldToggleLabel = '';

	constructor(private store: StoreService, private contentService: ContentService) { }

	public ngOnInit(): void {
		this.initStoreYieldInfo();
		this.initYieldToggleLabel();
	}

	public onYieldFlagChange(): void {
		this.includeYield = !this.includeYield;
		this.includeYieldChange.emit(this.includeYield);
		if (!this.includeYield) {
			if (!this.showScenarioYield || !this.includeScenarioYield) {
				this.toggleYield();
			}
		}
	}

	public onScenarioYieldFlagChange(): void {
		this.includeScenarioYield = !this.includeScenarioYield;
		this.includeScenarioYieldChange.emit(this.includeScenarioYield);
		if (!this.includeYield && !this.includeScenarioYield) {
			this.toggleYield();
		}
	}

	public onSendEmail(): void {
		this.clientEmailChange.emit();
	}

	public toggleYield(): void {
		this.toggleShowYield();
		this.includeYield = this.showYield;
		if (!this.isScenarioAdvisoryFeeEnabled) {
			this.includeScenarioYield = this.showYield;
		}

		this.includeYieldChange.emit(this.includeYield);
		this.includeScenarioYieldChange.emit(this.includeScenarioYield);
	}

	public toggleShowYield(): void {
		this.showYield = !this.showYield;
	}

	private initYieldToggleLabel(): void {
		this.yieldToggleLabel = this.contentService.get(
			this.isScenarioAdvisoryFeeEnabled ? 'PDF_GENERATE_YIELD_HEADER_SCENARIO_ADVISORY_FEE' : 'PDF_GENERATE_YIELD_HEADER',
			this.isScenarioAdvisoryFeeEnabled ? 'Include Yield in Snapshot & Fixed Income Characteristics' : 'Include Yield'
		);
	}

	private initStoreYieldInfo(): void {
		this.store.selectAll(PdfGenerateStoreConfig.reportConfig).pipe(first()).subscribe(data => {
			this.includeScenarioYield = get(data, 'includeScenarioYield', false);
			this.showYield = this.includeYield || (this.includeScenarioYield && !this.isScenarioAdvisoryFeeEnabled);
			this.includeYieldChange.emit(this.includeYield);
			this.includeScenarioYieldChange.emit(this.includeScenarioYield);
		});
	}
}
